// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__35wpz","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1ZowL"};